(function(){
  if(window.__sppCartPolishLoaded) return;
  window.__sppCartPolishLoaded = true;

  const replacements = new Map([
    ['same-day dispatch before 2pm','Easy 14-Day Returns'],
    ['dispatch before 2pm','14-Day Returns'],
    ['fast delivery','Customer Support'],
    ['free delivery over r2000','Free delivery over R2000*']
  ]);

  function normalise(value){
    return String(value || '').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function replaceExactText(root){
    if(!root) return;
    const selectors = [
      '.spp-cart__hero-point strong',
      '.spp-cart__trust-text strong',
      '.spp-cart-note__mini-text strong',
      '.spp-cart-badge__text',
      '.spp-cart-badge strong'
    ].join(',');
    root.querySelectorAll(selectors).forEach(el=>{
      const key = normalise(el.textContent);
      if(replacements.has(key)) el.textContent = replacements.get(key);
    });
  }

  function addDeliveryNotes(){
    const targets = [
      document.querySelector('.spp-cart__trust'),
      document.querySelector('.spp-cart-note__mini')
    ];
    targets.forEach(target=>{
      if(!target || target.parentElement.querySelector('.spp-cart__delivery-note')) return;
      const note = document.createElement('p');
      note.className = 'spp-cart__delivery-note';
      note.textContent = '*Free delivery excludes TVs and bulky items.';
      target.insertAdjacentElement('afterend', note);
    });
  }

  function drawerServiceMarkup(){
    const bar = document.createElement('div');
    bar.className = 'spp-drawer-service';
    bar.innerHTML =
      '<div class="spp-drawer-service__delivery">' +
        '<span class="spp-drawer-service__icon" aria-hidden="true">✓</span>' +
        '<span class="spp-drawer-service__copy">' +
          '<strong>Free delivery over R2000*</strong>' +
          '<small>*Excludes TVs & bulky items</small>' +
        '</span>' +
      '</div>' +
      '<a class="spp-drawer-service__wa" target="_blank" rel="noopener" href="https://wa.me/27632422467?text=Hi%20Smart%20Pick%20%26%20Pay%2C%20I%20need%20help%20with%20my%20cart.">' +
        '<span>Need help? WhatsApp us</span><span aria-hidden="true">→</span>' +
      '</a>';
    return bar;
  }

  function polishDrawer(){
    const drawer = document.querySelector('cart-drawer');
    if(!drawer) return;

    const heading = drawer.querySelector('.drawer__heading');
    if(heading && normalise(heading.textContent) !== 'your cart') heading.textContent = 'Your Cart';

    const header = drawer.querySelector('.drawer__header');
    if(header && !drawer.querySelector('.spp-drawer-service')){
      header.insertAdjacentElement('afterend', drawerServiceMarkup());
    }

    const checkout = drawer.querySelector('.cart__checkout-button, button[name="checkout"]');
    if(checkout){
      const text = normalise(checkout.textContent);
      if(text === 'check out' || text === 'checkout') checkout.textContent = 'Secure Checkout';
    }

    const footer = drawer.querySelector('.drawer__footer');
    if(footer && !footer.querySelector('.spp-drawer-view-cart')){
      const link = document.createElement('a');
      link.className = 'spp-drawer-view-cart';
      link.href = '/cart';
      link.textContent = 'View Full Cart';
      const buttons = footer.querySelector('.cart__ctas');
      if(buttons) buttons.insertAdjacentElement('afterend',link);
      else footer.appendChild(link);
    }
  }

  function apply(){
    replaceExactText(document);
    addDeliveryNotes();
    polishDrawer();
  }

  function ready(){
    apply();
    const drawer = document.querySelector('cart-drawer');
    if(drawer){
      let queued = false;
      new MutationObserver(()=>{
        if(queued) return;
        queued = true;
        requestAnimationFrame(()=>{
          queued = false;
          polishDrawer();
        });
      }).observe(drawer,{childList:true,subtree:true});
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready,{once:true});
  else ready();
})();
